import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../../../NotFound'
import { AbilityContext } from '../../../../components/Ability'
import LeadImportPage from './Features/LeadImport'
import LeadListPage from './Features/LeadList'
import LeadDetailPage from './Features/LeadDetail'
import LeadListCancelPage from './Features/LeadListCancel'
import LeadListFollowPage from './Features/LeadListFollow'
import LeadListNotificationPage from './Features/LeadListNotification'
import LeadCalenderPage from './Features/LeadCalender'

const LeadPage = () => {
  const ability = useContext(AbilityContext)
  return (
    <Routes>
      <Route
        path="/import"
        element={
          ability.can('manage', 'CRM', 'importLead') ? (
            <LeadImportPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/list"
        element={
          ability.can('manage', 'CRM', 'allFollow') ? (
            <LeadListPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/cancel"
        element={
          ability.can('manage', 'CRM', 'cancelFollow') ? (
            <LeadListCancelPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/follow"
        element={
          ability.can('manage', 'CRM', 'notificationFollow') ? (
            <LeadListFollowPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/calendar"
        element={
          ability.can('manage', 'CRM', 'calendarFollow') ? (
            <LeadCalenderPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/notification"
        element={
          ability.can('manage', 'CRM', 'reportFollow') ? (
            <LeadListNotificationPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/detail/:objectId"
        element={
          ability.can('manage', 'CRM', 'allFollow') ? (
            <LeadDetailPage />
          ) : (
            <NotFound />
          )
        }
      />
    </Routes>
  )
}

export default LeadPage
